"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  SWMessageChannel: () => SWMessageChannel,
  register: () => register_default
});
module.exports = __toCommonJS(src_exports);

// src/register.ts
var register = async (swUrl) => {
  try {
    await navigator.serviceWorker.register(swUrl, { scope: "/" });
  } catch (error) {
    console.error(`registration failed: ${error}`);
  }
};
var register_default = register;

// src/channel.ts
var SWMessageChannel = class {
  constructor() {
    __publicField(this, "channel");
    this.channel = new BroadcastChannel("sw-entitlements");
  }
  sendMessage(type) {
    this.channel.postMessage({ type });
  }
  listenForMessage(callback) {
    const listener = (event) => {
      callback(event);
    };
    this.channel.addEventListener("message", listener);
    return () => {
      this.channel.removeEventListener("message", listener);
    };
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SWMessageChannel,
  register
});
//# sourceMappingURL=index.js.map